exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.submitEndit .van-popup[data-v-37d151af] {\r\n  height: 300px;\r\n  width: 100%;\n}\n.submitEndit .van-cell__title[data-v-37d151af],\r\n.van-cell__value[data-v-37d151af] {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: flex;\r\n  -webkit-box-pack: justify;\r\n  -webkit-justify-content: space-between;\r\n          justify-content: space-between;\r\n  width: 100%;\n}\r\n", ""]);

// exports
